import React__default, { forwardRef } from "react";
import { Box } from "../Box/Box.js";
import { useStyles } from "./Spacer.styles.js";
const Spacer = forwardRef(
  ({
    centered = false,
    children = null,
    className = "",
    direction = "horizontal",
    gap = "s",
    style = {},
    ...props
  }, ref) => {
    const classes = useStyles({ centered, direction, gap, style });
    return /* @__PURE__ */ React__default.createElement(Box, { ref, className: `${classes.wrapper} ${className}`, ...props }, /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children));
  }
);
export {
  Spacer
};
//# sourceMappingURL=Spacer.js.map
